<!-- 现场退次 申诉 页面 -->
<template>
  <ComponentAppeal :kindType="data.kindType" :getData="data.getData" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading" v-if="data.kindType == 'sqmAdd' || data.getData.badTypename"></ComponentAppeal>
  <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>

<script setup>
import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import ComponentAppeal from "../../views/RejectsManageAppeal/ComponentAppeal"
const { proxy, ctx } = getCurrentInstance()
const route = useRoute()

const data = reactive({
  kindType: '',
  getData: {},
  subLoading: false,
  pageLoading: false,
})
const routerBack = () => {
  proxy.$router.back()
}
const submit = (val) => {
  // 提交确认
  // 创建时需要生成唯一键******appealId
  if (val.badTypename == "现场不良") {
    val.appealId = "SS" + new Date().getTime();
    val.inputId = data.supplyCode;
    val.inputName = data.getData.trueName;
    val.badType = 1299;
    val.userId = data.supplyCode;
    val.appealStatusid = 2141;
    val.badId = val.badId;
    val.badDescribe = val.flawMark;
    val.flawMark = val.flawMark;
    val.batchFailId = val.batchFailId;
    val.uuid = val.uuid;
    val.uuidFail = val.uuid;
    val.goodsSort = val.goodsSort;
    val.checkTime = val.checkTime;
  }
  // 去除 inputDate
  val.inputDate = undefined;
  data.subLoading = true;
  proxy.$http({
    url: "/base/RefusalAppeal/saveOrUpdate",
    method: "post",
    data: { ...val }
  }).then((res => {
    if (res.data.code === '0') {
      proxy.success({
        title: '成功', message: res.data.data || '提交成功', confirmButtonText: '确定',
        callback: (action) => {
          routerBack()
        }
      })
    } else {
      proxy.info(res.data.msg || "提交失败!")
    }
  })).catch(err => {
    proxy.warning(err)
  }).finally(() => {
    data.subLoading = false
  })
}

const getInfo = (appealId, type) => {
  data.pageLoading = true
  if (!route.query.badTypename) {
    return
  }
  proxy.$http({
    method: "get",
    url: `/base/RefusalAppeal/selectRejectsByKey?appealid=${appealId}`,
  }).then((res) => {
    data.getData = res.data.data;
  }).catch(err => {

  }).finally(() => {
    data.pageLoading = false
    type && (data.getData.type = type)
  })

}
const init = () => {
  data.pageLoading = true
  data.getData.rejectsId = route.query.rejectsId
  data.pageLoading = false
}

onBeforeMount(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode ? route.query.supplyCode : ''
    data.supplyName = route.query.supplyName ? route.query.supplyName : ''
    data.getData.supplyCode = route.query.supplyCode ? route.query.supplyCode : ''
    data.getData.supplyName = route.query.supplyName ? route.query.supplyName : ''
    //现场退次优化：入厂不合格、实验不合格、停检不合格、现场退次、不良申诉发起申诉时，申诉人获取供应商的 username（现获取的是truename）
    data.trueName = route.query.trueName ? route.query.trueName : ''
    data.userName = route.query.userName ? route.query.userName : ''
    data.getData.trueName = data.trueName ? data.trueName : data.userName
    data.conformityDeclarationsId = route.query.conformityDeclarationsId ? route.query.conformityDeclarationsId : undefined
    data.sourceId = route.query.sourceId ? route.query.sourceId : undefined
    data.uuid = route.query.uuid ? route.query.uuid : ''
    if (route.query.type) {
      data.getData.type = route.query.type
    }
    if (route.query.kindType) {
      data.kindType = route.query.kindType
    } else {
      data.kindType = 'sqmDetail'
    }
    if (data.kindType == 'sqmDetail') {
      getInfo(route.query.appealId, route.query.type)
    }
    if (route.query.comeFrom == '现场退次') {
      init()
    }
  }
})
onMounted(() => {
  if (route.query.dataFrom != 'sqm') {
    proxy.$router.replace('/404')
    return
  }
  if (!route.query.supplyCode) {
    proxy.info({
      title: '提示', message: '请先登录或重新登录后再试', confirmButtonText: "确定",
      callback: (action) => {
        routerBack()
      },
    })
    return
  }

  proxy.changeHeight()
})
</script>

<style></style>